import {Component, OnInit} from '@angular/core';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router} from '@angular/router';
import { filter } from 'rxjs/operators';
import {animate, state, style, transition, trigger} from '@angular/animations';
/**
 * Компонент для визуализации перехода по страницам.
 * Представляет собой полоску вверху экрана, которая заполняется, пока происходит навигация
 */

@Component({
    selector: 'app-navigation-progress',
    template: `
        <div [@progress]="progress ? 'opened' : 'closed'" class="progress"></div>
    `,
    styleUrls: ['./navigation-progress.component.scss'],
    animations: [
        trigger('progress', [
            state('opened', style({
                width: '100%',
                opacity: 1,
            })),
            state('closed', style({
                width: '100%',
                opacity: 0,
            })),
            transition('closed => opened', [
                style({
                    width: 0,
                    opacity: 1,
                }),
                animate('60s cubic-bezier(.27,1,.23,1)')
            ]),
            transition('opened => closed', [
                style({
                    opacity: 1,
                }),
                animate(400)
            ])
        ]),
    ]
})

export class NavigationProgressComponent implements OnInit {

    public progress: boolean;

    constructor(
        private router: Router,
    ) {
    }

    ngOnInit() {
        this.router.events.pipe(
                filter((event) => event instanceof NavigationStart)
            ).subscribe((event) => {
                this.progress = true;
            });


        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel)
        )
            .subscribe((event) => {
                this.progress = false;
            });
    }
}
